<template>
  <div class="page-wrapper">

    <div v-if="isMobile==false" class="container logo-container">
      <div class="row">
        <div class="col-12">
          <img src="@/assets/images/logo.gif"/> {{version}}
        </div>
      </div>
    </div>


    <div class="container">
      <div class="row nav-container">
        <ul>

          <li><a class="active" href="#/home/">메인</a></li>
          <li><a href="#/history/">기록</a></li>
          <li><a href="#/mypage/">마이페이지</a></li>
          <li>
            <i class="fas fa-sign-out-alt logout-btn" v-on:click="logout"></i>
          </li>
        </ul>
      </div>
    </div>

    <div class="container">
      <div class="row border main-nav" style="position: relative;">

        <div class="state-button-bg" v-bind:class="{'state-0': filter.state ==0, 'state-1': filter.state == -1}">

        </div>
        <div class="col-2 state-button" v-bind:class="{'state-selected' : filter.state == 0}" v-on:click="stateChange(0)">
          출고준비
        </div>
<!--        <div class="col-2 state-button" v-bind:class="{'state-selected' : filter.state == -1}" v-on:click="stateChange(-1)">-->
<!--          출고보류-->
<!--        </div>-->
      </div>
    </div>
    <div class="container menu-list-container">
      <div class="row" style="padding-bottom:10px;">
        <label class="col-12 col-md-1 form-control">
          송장번호:
        </label>
        <div class="col-12 col-md-2">
          <input type="text" class="form-control" v-model="filter.awb"/>
        </div>
        <label class="col-12 col-md-1 form-control">
          수취인:
        </label>
        <div class="col-12 col-md-2">
          <input type="text" class="form-control" v-model="filter.receiver"/>
        </div>
        <div class="col-12 col-md-2">
          <button type="button" class="btn btn-primary form-control" v-on:click="getPendingList()">가져오기</button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-left">
          <div v-show="newItem == false" class="image-btn-container" v-on:click="openNewItem()"
               style="background: #FFA6A6;">
            <div class="image-btn"
                 v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/ic_add_doc.png') + ')'}"/>
            송장등록
          </div>
          <div v-show="newItem == false && isMobile==false" class="image-btn-container" v-on:click="downloadForm()">
            <div class="image-btn"
                 :style="{backgroundImage: 'url(' + require('@/assets/images/ic_down_template.png') + ')'}"/>
            엑셀양식받기
          </div>
          <div class="image-btn-container" v-on:click="printSelectedLabels()" v-if="customerPrinterAvailable == true && items.length > 0 && isMobile==false">
            <div class="image-btn" :style="{backgroundImage: 'url(' + require('@/assets/images/ic_print.svg') + ')'}"/>
            송장출력(네트워크 라벨프린터)
          </div>
          <div class="image-btn-container" v-on:click="printItems()" v-if="items.length > 0 && isMobile==false">
            <div class="image-btn" :style="{backgroundImage: 'url(' + require('@/assets/images/ic-label-3x1.png') + ')'}"/>
            송장출력(USB 라벨프린터)
          </div>
          <div class="image-btn-container" v-on:click="printItems(1)" v-if="items.length > 0 && isMobile==false">
            <div class="image-btn" :style="{backgroundImage: 'url(' + require('@/assets/images/ic-label-3x1.png') + ')'}"/>
            송장출력(USB 라벨프린터 가로)
          </div>
          <div class="image-btn-container" v-on:click="printItems(2)" v-if="items.length > 0 && isMobile==false">
            <div class="image-btn" :style="{backgroundImage: 'url(' + require('@/assets/images/ic-label-3x1.png') + ')'}"/>
            송장출력(A4 가로3)
          </div>
          <div class="image-btn-container" v-on:click="printItems(3)" v-if="items.length > 0 && isMobile==false">
            <div class="image-btn" :style="{backgroundImage: 'url(' + require('@/assets/images/ic-label-2x2.png') + ')'}"/>
            송장출력 (A4 2x2)
          </div>
          <div class="image-btn-container" v-on:click="downloadForCustomerH()" v-if="items.length > 0">
            <div class="image-btn"
                 :style="{backgroundImage: 'url(' + require('@/assets/images/ic_download.png') + ')'}"/>
            엑셀다운 (가로)
          </div>
          <div class="image-btn-container" v-on:click="downloadForCustomerV()" v-if="items.length > 0">
            <div class="image-btn"
                 :style="{backgroundImage: 'url(' + require('@/assets/images/ic_download.png') + ')'}"/>
            엑셀다운 (세로)
          </div>
          <div class="image-btn-container" @click="onfileselectorClick" style="background: #8BE6FF;">
            <input type="file" ref="file" style="display: none" v-on:change="addFilePickedUp">
            <div class="image-btn"
                 :style="{backgroundImage: 'url(' + require('@/assets/images/ic_upload.svg') + ')'}" />
            엑셀업로드
          </div>
          <div class="image-btn-container" v-on:click="deleteSelected()" v-if="selectedItems.length > 0">
            <i class="fas fa-trash"></i>지우기
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-left">
        </div>
      </div>
      <div class="col-3" v-if="isMobile==false" style="display: none;">

        <div class="drop-zone" v-cloak @drop.prevent="addFile" @dragover.prevent @dragenter="dragEnter"
             @dragleave="dragLeave" @dragend="dragEnd" v-bind:class="{'drop-enabled': dropEnabled == true}" >
          엑셀업로드

        </div>
      </div>

    </div>
    <transition name="vertical">
      <div class="new-item-form" v-if="newItem != false">
        <div class="scroll-container">
          <div class="container  view-with-bottom-menu">
            <div class="row">
              <div class="col-12">
                <h4 v-if="newItem.id == 0">송장등록</h4>
                <h4 v-if="newItem.id > 0">송장수정 [{{newItem.awb}}]</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-4">
                <div class="card">
                  <div class="card-header">
                    <h4>보내는사람</h4>
                  </div>
                  <div class="card-body">
                    <div class="container">
                      <div class="form-group row">
                        <div class="col-4">업체</div>
                        <div class="col-8">
                          <input type="text" class="form-control" :value="user.title" disabled/>

                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">업체코드</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.code" disabled/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">보내는사람</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.sender" disabled/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">Address 1</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.sender_address_1" disabled/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">Address 2</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.sender_address_2" disabled/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">POST CODE</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.sender_post_code" disabled/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">CONTACT</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.sender_contact" disabled/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-4">
                <div class="card">
                  <div class="card-header">
                    <h4>배송정보</h4>
                  </div>
                  <div class="card-body">
                    <div class="container">

                      <div class="form-group row">
                        <div class="col-4">배송일</div>
                        <div class="col-8">
                          <input type="date" class="form-control" v-model="newItem.dispatch_date"
                                 v-on:change="verifySendDate()" placeholder="Date" :disabled="newItem.state >= 1"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">주문번호</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.order_number"
                                 :disabled="newItem.state >= 1"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">CT</div>
                        <div class="col-8">
                          <input type="number" class="form-control" v-model="newItem.ct" :disabled="newItem.state >= 1"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">화주종류</div>
                        <div class="col-8">
                          <select class="form-control" v-model="newItem.seller_type" :disabled="newItem.state >= 1">
                            <option value="2">회사</option>
                            <option value="1">개인</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">통관종류</div>
                        <div class="col-8">
                          <select class="form-control" v-model="newItem.custom_type" :disabled="newItem.state >= 1">
                            <option value="목">목록통관</option>
                            <option value="일">일반통관</option>
                            <option value="간">간이통관</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">거래구분</div>
                        <div class="col-8">
                          <select class="form-control" v-model="newItem.trade_type" :disabled="newItem.state >= 1">
                            <option value="A">전자상거래</option>
                            <option value="C">일반</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">관세청구</div>
                        <div class="col-8 col-md-4">
                          <select class="form-control" v-model="newItem.who_pays_tax" :disabled="newItem.state >= 1">
                            <option value="0">Default</option>
                            <option value="1">수취인</option>
                            <option value="2">발송인</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">관세사비용청구</div>
                        <div class="col-8 col-md-4">
                          <select class="form-control" v-model="newItem.who_pays_inspection"
                                  :disabled="newItem.state >= 1">
                            <option value="0">Default</option>
                            <option value="1">수취인</option>
                            <option value="2">발송인</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">배송메모</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.note"
                                 @keyup="checkSpecialKey(newItem.note)" :disabled="newItem.state >= 1"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">
                          VALUE(USD):
                        </div>
                        <div class="col-8 col-md-4">
                          <input type="number" class="form-control" v-model="newItem.value"
                                 placeholder="Product Value in USD" :disabled="newItem.state >= 1" disabled/>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="card">
                  <div class="card-header">
                    <h4>받는사람</h4>
                  </div>
                  <div class="card-body">
                    <div class="container">

                      <div class="form-group row">
                        <div class="col-4">받는사람</div>
                        <div class="col-6" v-bind:class="{'col-8': newItem.state >= 1}">
                          <input type="text" class="form-control" v-model="newItem.receiver"
                                 :disabled="newItem.state >= 1" @keyup.enter="findReceiver"/>
                        </div>
                        <div class="col-2" style="padding-left: 0;line-height: 34px;" v-if="newItem.state == 0">
                          <i class="fas fa-search" v-on:click="findReceiver()"
                             :disabled="newItem.state >= 1"></i>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">통관번호</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.custom_number"
                                 :disabled="newItem.state >= 1"/>
                        </div>
                      </div>

                      <div class="form-group row">
                        <div class="col-4">우편번호</div>
                        <div class="col-6">
                          <input type="text" class="form-control" v-model="newItem.post_code"
                                 :disabled="newItem.state >= 1"/>
                        </div>
                        <div class="col-2" style="padding-left: 0;line-height: 34px;"  v-if="newItem.state == 0">
                          <i class="fa fa-search" v-on:click="findAddress()"
                             :disabled="newItem.state >= 1"></i>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">주소</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.address_1"
                                 :disabled="newItem.state >= 1"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">상세주소</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.address_2"
                                 :disabled="newItem.state >= 1"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">주민번호</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.national_id"
                                 :disabled="newItem.state >= 1"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">연락처</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.receiver_contact"
                                 :disabled="newItem.state >= 1"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">이메일</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="newItem.email" :disabled="newItem.state >= 1"/>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12" style="margin-top:20px;">
                <div class="card">
                  <div class="card-header">
                    <h4>물품 리스트</h4>
                  </div>
                  <div class="card-body">


                    <div class="row">

                      <div class="col-12" v-bind:class="{'mobile-horizontal-scroll':isMobile==true}">
                        <table class="table" v-bind:class="{'mobile-product-input-table':isMobile == true}">
                          <tr>
                            <th>브랜드</th>
                            <th>상품명</th>
                            <th>상품URL</th>
                            <th>HS Code</th>
                            <th>원산지</th>
                            <th>수량</th>
                            <th>단가</th>
                            <th style="min-width: 100px;">총</th>
                            <th v-if="useLiquid">액체류</th>
                          </tr>
                          <tr v-for="(item, index) in newItem.list">
                            <td><input type="text" class="form-control" v-model="item.brand"
                                       @input="item.brand = $event.target.value.toUpperCase()"
                                       @keyup="checkBrandSpecialKey(index)" :disabled="newItem.state >= 1"/></td>
                            <td><input type="text" class="form-control" v-model="item.product"
                                       @input="item.product = $event.target.value.toUpperCase()"
                                       @keyup="onProductEntered(index)" :disabled="newItem.state >= 1"/></td>
                            <td><input type="text" class="form-control" v-model="item.site_url"
                                       @keyup="onProductEntered(index)" :disabled="newItem.state >= 1"/></td>

                            <td>
                              <select class="form-control" v-model="item.hs_code" :disabled="newItem.state >= 1">
                                <option value="-1">Select</option>
                                <option v-for="(code, index) in hsCodes" :value="code.textVal">({{code.textVal}}){{code.title}}
                                </option>
                              </select>
                            </td>
                            <td>
                              <input type="text" class="form-control" v-model="item.origin_country"
                                     @input="item.origin_country = $event.target.value.toUpperCase()"
                                     :disabled="newItem.state >= 1"/>

                            </td>
                            <td><input type="number" class="form-control" v-model="item.amount"
                                       :disabled="newItem.state >= 1" @keypress="onlyNumber" pattern="[0-9]*" @keyup="calculateTotalValue"/></td>
                            <td><input type="number" class="form-control" v-model="item.value"
                                       :disabled="newItem.state >= 1" @keyup="calculateTotalValue"/></td>
                            <td>{{(item.amount*item.value).toFixed(2)}}</td>
                            <td v-if="useLiquid">
                              <select class="form-control" v-model="item.liquid" :disabled="newItem.state >= 1">
                                <option value="0">No Liquid</option>
                                <option value="1">Liquid</option>
                              </select>
                            </td>
                          </tr>
                        </table>
                        <button type="button" class="btn btn-primary" v-on:click="onAddGood()"
                                :disabled="newItem.state >= 1">추가하기
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row fixed-bottom bottom-menu">
              <div class="col-6" v-bind:class="{'col-12': newItem.state > 0}">
                <div class="bottom-button neutral-btn" v-on:click="closeNewItemForm()">Close</div>
              </div>
              <div class="col-6" v-if="newItem.state == 0">
                <div v-if="newItem.id == 0" class="bottom-button positive-btn" v-on:click="submitNewItem()">CREATE</div>
                <div v-if="newItem.id > 0" class="bottom-button positive-btn" v-on:click="submitNewItem()">UPDATE</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="container">
      <table class="table">
        <tr>
          <th>#</th>
          <th style="cursor:pointer"  v-if="isMobile==false" v-on:click="selectAll()">선택</th>
          <th style="cursor:pointer"  v-on:click="sortByDispatchDate">출발 <i class="fa fa-sort" style="float:right;font-size: 22px;"></i></th>
          <th style="cursor:pointer"  v-on:click="sortByOrderNumber">주문번호 <i class="fa fa-sort" style="float:right;font-size: 22px;"></i></th>
          <th style="cursor:pointer"  v-on:click="sortByAWB">송장 <i class="fa fa-sort" style="float:right;font-size: 22px;"></i></th>
          <th>상태</th>
          <th style="cursor:pointer"  v-on:click="sortByReceiver">수신 <i class="fa fa-sort" style="float:right;font-size: 22px;"></i></th>
          <th v-if="isMobile==false">연락처</th>
          <th v-if="isMobile==false">Description</th>
          <th v-if="isMobile==false">Value</th>
          <th v-if="isMobile==false">GW / CW</th>

          <th v-if="isMobile==false"></th>
<!--          <th v-if="isMobile==false"></th>-->
        </tr>
        <tbody name="list" is="transition-group">
            <tr v-for="(item, index) in items" class="hovorable-item" :key="'item-'+filter.state + '-' + item.id">
              <td>{{index+1}}</td>
              <td v-if="isMobile==false"><input type="checkbox" v-bind:value="index" v-model="selectedItems"
                                                @click="updateCheckall($event, index)"/></td>
              <td style="min-width:100px;">{{item.dispatch_date}}</td>
              <td>{{item.order_number}}</td>
              <td style="min-width:150px;"><span  class="clickable-item" v-on:click="editItem(index)">{{item.awb}}</span></td>
              <td style="min-width:100px;">{{getStateString(item.state)}}</td>
              <td>{{item.receiver}}</td>
              <td style="min-width:150px;" v-if="isMobile==false">{{item.receiver_contact}}</td>
              <td class="text-left" v-if="isMobile==false">{{getDescriptionList(item.list)}}</td>
              <td v-if="isMobile==false">${{item.value}}</td>
              <td v-if="isMobile==false">{{(item.measured_weight/100).toFixed(1)}} / {{(item.volume_weight/100).toFixed(1)}}
              </td>
              <td v-if="isMobile==false">
                <div v-show="false" class="image-btn"
                     :style="{backgroundImage: 'url(' + require('@/assets/images/ic_edit.png') + ')'}"
                     v-on:click="editItem(index)" style="display: none;"/>
                <div v-if="isMobile==false" class="image-btn" style="display: none;"
                     :style="{backgroundImage: 'url(' + require('@/assets/images/ic_delete.png') + ')'}"
                     v-on:click="deleteItem(index)"/>

                <div v-if="customerPrinterAvailable == true && isMobile==false" class="image-btn"
                     :style="{backgroundImage: 'url(' + require('@/assets/images/ic_print.png') + ')'}"
                     v-on:click="printItem(index)" style="display: none;"/>
                <span v-if="isTodayDispatchDate(item.dispatch_date) == false" v-on:click="deleteItem(index)"><i class="fas fa-trash"></i></span>
                <span v-if="isMobile==false" style="display: none;"><i class="fa fa-file" v-on:click="getFTADoc(item.id)"> FTA</i></span>
              </td>
<!--              <td v-if="isMobile == false" style="min-width: 100px;">-->
<!--                <span class="border-btn" v-if="item.state==0 && isTodayDispatchDate(item.dispatch_date) == false" v-on:click="checkChangeable(index, -1)">보류하기</span>-->
<!--                <span class="border-btn" v-if="item.state==-1" v-on:click="checkChangeable(index, 0)">출고준비</span>-->
<!--              </td>-->
            </tr>

        </tbody>
      </table>
    </div>
    <div id="finder-container" class="fullscreen-container">
      <div id="postcodeFinderLayer" class="center-container">
        <img src="//t1.daumcdn.net/postcode/resource/images/close.png" id="btnCloseLayer"
             style="cursor:pointer;position:absolute;right:-3px;top:-3px;z-index:1" v-on:click="closeAddressFinder()"
             alt="닫기 버튼"/>
      </div>
    </div>
    <div class="fullscreen-search-list-container" v-if="existingReceivers.length > 0">
      <div class="inside-container">

        <div class="container-fluid search-list-container">
          <div class="row h-100">
            <div class="col-12 h-100 scroll-container" style="padding-top:90px;">
              <table class="table">
                <tr v-for="(item, index) in existingReceivers" v-on:click="onSelectFromReceiverList(index)" class="search-result-item">
                  <td>{{item.receiver}}</td>
                  <td>{{item.post_code}}</td>
                  <td>{{item.address_1}} {{item.address_2}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="container-fluid search-list-title">
          <div class="row">
            <div class="col-8">
              <h2>수취인 리스트</h2>
            </div>
            <div class="col-4 text-right">
              <span v-on:click="closeReceiverSearchList">닫기</span>
            </div>
          </div>

        </div>
      </div>
    </div>


    <transition name="vertical">
      <div class="receipt-container" v-if="showLabelPrint == true">
        <div class="receipt-inner-container">
          <div class="scroll-container">
            <iframe class="myiframe" id="label-print"  v-bind:class="{'iframe-a4-l': paperType==1 , 'iframe-a4-p': paperType == 2}" v-bind:src="labelHtml"
              scrolling=yes
              height="100%"
              name="labelFrame"></iframe>

<!--            <div class="label-container" id="label-print-embed"  v-bind:class="{'iframe-a4-l': paperType==1 , 'iframe-a4-p': paperType == 2}" v-html="labelHtml">-->

<!--            </div>-->
            <!--          <div class="container" v-html="labelHtml">-->
            <!--          </div>-->
          </div>
          <span class="top-left-btn" v-on:click="closeLabelView"><i class="fas fa-window-close"></i>닫기</span>
        </div>
      </div>
    </transition>
    <div class="spinner-container" v-if="isLoading">
      <div class="spinnermedium">
        <span class="bgtopl"><span class="highlighttopl"></span></span>
        <span class="bgtopr"><span class="highlighttopr"></span></span>
        <span class="bottomrow">
            <span class="bgbtml"><span class="highlightbtml"></span></span>
            <span class="bgbtmr"><span class="highlightbtmr"></span></span>
          </span>
      </div>
    </div>

    <v-dialog/>
  </div>
</template>
<script>
    require('@/assets/css/styles.css')
    import printJS from 'print-js'

    //'use strict';
    //const excelToJson = require('convert-excel-to-json');
    import Router from '../router';
    import VModal from '../router';
    import axios from 'axios';
    import {getItem} from '../api/general'
    import {getDepotCode, requestPrintLabel} from '../api/parcel'
    import {
      downloadFTADoc,
      getStateString,
      getStateTimeString,
      millisToDate,
      escapeLineChange,
      getTimeStamp,
      escapeSpecialCharacters,
      getVersion
    } from '../api/Utils'
    import moment from 'moment'

    export default {
        name: 'Home',
        data() {
            return {
                version:'',
                msg: 'Home',
                user: {
                    id: 0,

                },
                filter: {
                    date_from: '',
                    date_to: '',
                    awb: '',
                    receiver: '',
                    state: 0,
                },
                forwarders: [],
                countries: [],
                hsCodes: [],
                items: [],
                newItem: false,
                showAddressFinder: false,
                files: [],
                dropEnabled: false,
                state: {
                    tickets: [{name: "test"}],
                    headers: ["Test header"]
                },

                isCheckAll: false,
                selectedItems: [],

                isMobile: false,
                showLabel: false,
                labelHtml: false,

                isLoading: false,
                useLiquid: false,

                existingReceivers:[],

                customerPrinterAvailable: false,


                showLabelPrint:false,
                showLabelPrint2:false,
                labelHtml2: false,
                //labelHtml:false
                paperType:0,

                sortList: {
                    awb:false,
                    code:false,
                    dispatch_date:false,
                    receiver:false,
                    sender: false,
                    orderNumber: false,
                }
            }
        },
        created: function () {
            this.$data.version = getVersion();
            console.log("width " + screen.width);
            this.$data.isMobile = isFromMobile();
            console.log("is Mobile " + this.$data.isMobile);
            //document.addEventListener("backbutton", this.backButtonHandler, false);
            this.$data.user.id = localStorage.getItem('id');


        },
        mounted: function () {
            this.getCustomerInfo();

            registerBackKeyHandler(this.backHandler);
        },
        beforeDestroy() {
            registerBackKeyHandler(false);
        },
        watch: {
            'newItem.note': function (newVal, oldVal) {
                if (this.$data.newItem == false) {
                    return;
                }
                if (newVal.includes('"') || newVal.includes("'")) {
                    this.$data.newItem.note = newVal.replace(/[^a-zA-Z ]/g, "");
                    this.showModal("에러", "특수문자는 사용할수 없숩니다");
                }
            },
            'newItem.receiver': function (newVal, oldVal) {
                if (this.$data.newItem == false) {
                    return;
                }
                if (newVal.includes('"') || newVal.includes("'")) {
                    this.$data.newItem.receiver = newVal.replace(/[^a-zA-Z ]/g, "");
                    this.showModal("에러", "특수문자는 사용할수 없숩니다");
                }
            },
            'newItem.address_1': function (newVal, oldVal) {
                if (this.$data.newItem == false) {
                    return;
                }
                if (newVal.includes('"') || newVal.includes("'")) {
                    this.$data.newItem.address_1 = newVal.replace(/[^a-zA-Z ]/g, "");
                    this.showModal("에러", "특수문자는 사용할수 없숩니다");
                }
            },
            'newItem.address_2': function (newVal, oldVal) {
                if (this.$data.newItem == false) {
                    return;
                }
                if (newVal.includes('"') || newVal.includes("'")) {
                    this.$data.newItem.address_2 = newVal.replace(/[^a-zA-Z ]/g, "");
                    this.showModal("에러", "특수문자는 사용할수 없숩니다");
                }
            }
        },
        methods: {
            showModal: function (title, message) {
                console.log("show modal " + title + " : " + message);
                this.$modal.show('dialog', {
                    title: title,
                    text: message,
                    buttons: [
                        {title: 'Close'}
                    ]
                })
                return;
            },
            getCustomerInfo: function() {

                var self = this;
                console.log("getForwarderList");
                var url = process.env.APP_URL + 'api/get_customer.php?id=' + this.$data.user.id;
                axios.get(url)
                  .then(response => {
                    console.log(response);
                    var data = response.data;
                    if (data.success) {
                      console.log(data.item);
                      self.$data.user.title = data.item.title
                      self.$data.user.address_1 = data.item.address_1;
                      self.$data.user.address_2 = data.item.address_2;
                      self.$data.user.post_code = data.item.post_code;
                      self.$data.user.code = data.item.code;
                      self.$data.user.contact_mobile = data.item.contact_mobile;
                      console.log("User Date");
                      console.log(this.$data.user);

                      let customerType = data.item.account_type;
                      let printerUrl = data.item.customer_printer;

                      console.log("Home create customerType " + customerType + " printerURL = " + printerUrl );
                      if(customerType != null && customerType != undefined && customerType != "" && printerUrl != undefined && printerUrl != undefined && printerUrl.length > 0) {
                        self.$data.customerPrinterAvailable = true;
                      } else {
                        self.$data.customerPrinterAvailable = false;
                      }
                      console.log("User Info");
                      console.log(self.$data.user);
                      self.getPendingList();
                      self.getForwarderList();
                    }
                  })
                  .catch(error => {

                  });

            },
            onlyNumber ($event) {
                //console.log($event.keyCode); //keyCodes value
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

                console.log("key code " + keyCode);
                if (keyCode < 48 || keyCode > 57 || keyCode == 46) { // 46 is dot
                    console.log("prevent");
                    return $event.preventDefault();
                }
                console.log("not prevent");
                // this.calculateTotalValue();
            },
            logout: function () {
                let self = this;
                this.$modal.show('dialog', {
                    //title: '로그아웃',
                    text: '로그아웃 하시겠습니까?',
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '로그아웃',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.onLogoutConfirmed();
                            }
                        },

                    ]

                });
            },
            onLogoutConfirmed: function () {
                localStorage.removeItem('id');
                localStorage.removeItem('email');
                localStorage.removeItem('level');
                localStorage.removeItem('admin');
                localStorage.removeItem('password');
                Router.push('/');
            },
            forceFileDownload(response) {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'utasco-form-customer-template.xlsx') //or any other extension
                document.body.appendChild(link)
                link.click()
            },
            downloadForm: function () {
                var url = 'static/utasco-form-customer-template.xlsx';
                var self = this;
                axios({
                    method: 'get',
                    url: url,
                    responseType: 'arraybuffer'
                })
                    .then(response => {

                        self.forceFileDownload(response)

                    })
                    .catch(() => console.log('error occured'))
            },
            addSelectField: function () {
                for (var i = 0; i < this.$data.items.length; i++) {
                    this.$data.items[i].selected = false;
                }
            },
            selectAll: function () {
                this.$data.isCheckAll = !this.$data.isCheckAll;
                this.$data.selectedItems = [];
                var unselectableFound = false;
                if (this.$data.isCheckAll) {
                    for (var key in this.$data.items) {
                        this.$data.selectedItems.push(key)

                    }
                }

            },
            updateCheckall: function (e, index) {
                console.log("updateCheckall");
                if (e.shiftKey) {
                    console.log("shif key clicked");
                    let lastIndex = 0;
                    if(this.$data.selectedItems.length > 0) {
                        lastIndex = this.$data.selectedItems[this.$data.selectedItems.length-1];
                    }

                    if(index > lastIndex) {
                        for(let i = lastIndex+1 ; i < index ; i++) {
                            let found = false;
                            for(let j = 0 ; j < this.$data.selectedItems.length ; j++) {
                                if(this.$data.selectedItems[j] === i) {
                                    this.$data.selectedItems.splice(j, 1);
                                    found = true;
                                    break;
                                }
                            }
                            if(found == false) {
                                this.$data.selectedItems.push(i);
                            }
                        }
                    } else {
                        for(let i = index+1 ; i < lastIndex ; i++) {
                            let found = false;
                            for(let j = 0 ; j < this.$data.selectedItems.length ; j++) {
                                if(this.$data.selectedItems[j] === i) {
                                    this.$data.selectedItems.splice(j, 1);
                                    found = true;
                                    break;
                                }
                            }
                            if(found == false) {
                                this.$data.selectedItems.push(i);
                            }
                        }
                    }
                }

                if (this.$data.selectedItems.length == this.$data.items.length) {
                    this.$data.isCheckAll = true;
                } else {
                    this.$data.isCheckAll = false;
                }
                console.log("check");
                console.log(this.$data.selectedItems);
            },
            printSelectedLabels: function () {
                let index = -1;
                if(this.$data.selectedItems.length == 0) {
                    this.showModal("", "출력할 송장을 선택해주세요");
                    return;
                }
                for (let i = 0; i < this.$data.selectedItems.length; i++) {
                    index = this.$data.selectedItems[i];
                    break;
                }

                if (index == -1) {
                    return;
                }
                console.log("printItem");
                let zipCode = this.$data.items[index].post_code;
                if(zipCode.includes(" ")) {
                    zipCode = zipCode.replace(" ", "");
                }
                let address = this.$data.items[index].address_1;
                if (this.$data.items[index].address_2.length > 0) {
                    address += ' ' + this.$data.items[index].address_2;
                }
                console.log("printItem zipCode = " + zipCode);
                console.log("printItem address = " + address);

                let self = this;
                this.$data.isLoading = true;
                getDepotCode(zipCode, address)
                    .then(function (data) {
                        self.$data.isLoading = false;
                        console.log("getDepotCode Response");
                        console.log(data);
                        if (data.cmmMsgHeader.successYN == 'Y') {
                            self.printLabel(index, data.delivAreaCdList, self.$data.items[index].ct, true);
                        }

                    })
                    .catch(function (err) {
                        self.$data.isLoading = false;
                        self.showModal("에러", "집배코드를 가져올수 없습니다. 주소와 우편번호를 확인해주세요");

                        console.log(err);
                        return;
                    })
            },
            printItems: function (type=0) {
                console.log(this.$data.selectedItems);
                if(this.$data.selectedItems.length == 0) {
                    this.showModal("", "출력할 송장을 선택해주세요");
                    return;
                }
                let ids = [];
                // for (let selectedItem in this.$data.selectedItems) {
                //     console.log("selected index " + selectedItem)
                //     ids.push(this.$data.items[selectedItem].id);
                // }
                for (let i = 0; i < this.$data.selectedItems.length; i++) {
                    ids.push(this.$data.items[this.$data.selectedItems[i]].id);
                }

                this.$data.paperType = type;
                var str = ids.join(",");

                console.log(str);
                var self = this;

                var url = process.env.APP_URL + 'api/';
                if(type == 0) {
                    url += 'print_labels.php?ids=' + str;
                } else if(type == 1) {
                    url += 'print_label_horizontal.php?ids=' + str;
                } else if(type == 2) {
                    url += 'print_labels_a4.php?ids=' + str;
                } else if(type == 3) {
                    url += 'print_labels_a4_2x2.php?ids=' + str;
                }
                console.log("URL = " + url);
                this.$data.labelHtml = url;
                this.$data.showLabelPrint = true;
//                 axios.get(url)
//                     .then(function(response) {
//                         console.log("label print data");
//                         console.log(response);
//                         if(response.data != undefined) {
//
//                             console.log("set response");
//                             self.$data.labelHtml = response.data;
//                             self.$data.showLabelPrint = true;
// }
//                     })
//                     .catch(function(error) {
//
//                     });
                //window.open(url);

            },
            printHtmlLable: function() {

            },
            closeLabelView: function() {
                this.$data.labelHtml = false;
                this.$data.showLabelPrint = false;
                this.$data.selectedItems = [];
            },
            printItem: function (index) {
                console.log("printItem");
                let zipCode = this.$data.items[index].post_code;
                if(zipCode.includes(" ")) {
                    zipCode = zipCode.replace(" ", "");
                }
                let address = this.$data.items[index].address_1;
                if (this.$data.items[index].address_2.length > 0) {
                    address += ' ' + this.$data.items[index].address_2;
                }
                console.log("printItem zipCode = " + zipCode);
                console.log("printItem address = " + address);

                let self = this;
                this.$data.isLoading = true;
                getDepotCode(zipCode, address)
                    .then(function (data) {
                        self.$data.isLoading = false;
                        console.log("getDepotCode Response");
                        console.log(data);
                        if (data.cmmMsgHeader.successYN == 'Y') {
                            self.printLabel(index, data.delivAreaCdList, self.$data.items[index].ct);
                        }

                    })
                    .catch(function (err) {
                        self.$data.isLoading = false;
                        self.showModal("에러", "집배코드를 가져올수 없습니다. 주소와 우편번호를 확인해주세요");
                        console.log(err);
                    })
            },
            printLabel: function (index, cdList, count, moveToNext = false) {
                let self = this;
                self.$data.isLoading = true;
                let extra = "수량 " + this.$data.items[index].ct + "-" + count;
                requestPrintLabel(cdList, this.$data.items[index], extra, localStorage.getItem("customer_printer"))
                    .then(function (response) {
                        console.log("PRINT LABEL DONE");
                        self.$data.isLoading = false;
                        let newCount = count -1;
                        if(newCount > 0) {
                            self.printLabel(index, cdList, newCount, moveToNext);
                            return;
                        }
                        if (moveToNext) {
                            for (let i = 0; i < self.$data.selectedItems.length; i++) {

                                if (self.$data.selectedItems[i] == index) {
                                    self.$data.selectedItems.splice(i, 1);
                                    if(self.$data.selectedItems.length > 0) {
                                        self.printSelectedLabels();
                                    }
                                }
                            }
                        }
                    })
                    .catch(function (err) {
                        self.$data.isLoading = false;
                        self.showModal("에러", "프린터를 연결할수 없습니다.");
                    })
            },
            dragEnter(e) {
                console.log("Drag Entered");
                this.$data.dropEnabled = true;
            },
            dragLeave(e) {
                console.log("dragLeave");
                this.$data.dropEnabled = false;
            },
            dragEnd(e) {
                console.log("dragEnd");
                this.$data.dropEnabled = false;
            },
            convertExcDateToString: function (excelDate) {

                var myDate = new Date((excelDate - (25567 + 2)) * 86400 * 1000);

                // = new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
                var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
                var date = ('0' + myDate.getDate()).slice(-2);
                var year = myDate.getFullYear();
                var formattedDate = year + '-' + month + '-' + date;
                return formattedDate;
                //return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
            },
            onfileselectorClick: function(){
                this.$refs.file.value = "";
                this.$refs.file.click()
            },
            addFilePickedUp(e) {
                console.log("addFilePickedUp");
                console.log(e)
                let self = this;
                if(e.target != undefined) {
                    if(e.target.files != undefined) {
                        console.log("PATH: " + e.target.files[0].name);
                        let droppedFiles = e.target.files;

                        ([...droppedFiles]).forEach(f => {

                            if(f == undefined) {
                                return;
                            }
                            var reader = new FileReader(),
                                name = f.name;

                            reader.onload = function (e) {
                                var results;
                                var data = e.target.result;


                                var fixedData = self.fixdata(data),
                                    workbook = XLSX.read(btoa(fixedData), {type: 'base64'}),
                                    firstSheetName = workbook.SheetNames[0],
                                    worksheet = workbook.Sheets[firstSheetName];
                                self.$data.state.headers = self.get_header_row(worksheet);
                                results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                                //self.$data.state.tickets=results;
                                console.log("Result");
                                //console.log(results);
                                var list = [];
                                var dispatchDate = '';

                                for (var i = 1; i < results.length; i++) {
                                    var result = results[i];
                                    console.log("index " + i);
                                    console.log(result);
                                    if(result.dispatch_date == undefined) {
                                      self.showModal("에러", "Dispatch Date항목을 찾을 수 없습니다. Template파일을 확인해주세요" );
                                      return;
                                    }
                                    // console.log("dispatchDate " + result.dispatch_date + " length " + result.dispatch_date.length);
                                    if (result.dispatch_date > 4000) {
                                        dispatchDate = self.convertExcDateToString(result.dispatch_date);
                                    } else if (result.dispatch_date.length > 0) {
                                        console.log("dispatchDate length " + result.dispatch_date.length);
                                        if (result.dispatch_date.length == 10) {
                                            if((result.dispatch_date).includes("-")) {
                                                dispatchDate = result.dispatch_date;
                                            } else if((result.dispatch_date).includes("/")) {
                                                dispatchDate = result.dispatch_date.replace("/", "-");
                                            }
                                        }
                                    }
                                    if (result.seller_type == "") {
                                        result.seller_type = "2";
                                    }
                                    if (result.trade_type == "") {
                                        result.trade_type = "A";
                                    }
                                    if (result.custom_type == "") {
                                        result.custom_type = "목";
                                    }


                                    if(result.receiver.includes('"') || result.receiver.includes("'") ) {
                                        self.showModal("에러", "수취인 " + result.receiver + " 특수문자는 사용하실 수 없습니다." );
                                        return;
                                    }
                                    if(result.address.includes('"') || result.address.includes("'") ) {
                                        self.showModal("에러", "수취인 " + result.receiver + " 주소 " + result.address + " 에 특수문자는 사용하실 수 없습니다." );
                                        return;
                                    }

                                    if(result.message != null && result.message != undefined && (result.message.includes('"') || result.message.includes("'")) ) {
                                        self.showModal("에러", "수취인 " + result.receiver + " 메모 " + result.message + " 에 특수문자는 사용하실 수 없습니다." );
                                        return;
                                    }

                                    result.address = escapeLineChange(result.address);
                                    result.message = escapeLineChange(result.message);

                                    if(result.receiver.length > 0 && result.address.length > 0) {
                                        let item = {
                                            code: self.$data.user.code,
                                            customer_id: self.$data.user.id,
                                            dispatch_date: dispatchDate,//self.convertExcDateToString(dispatchDate),
                                            sender: self.$data.user.title,
                                            sender_address_1: self.$data.user.address_1,
                                            sender_address_2: self.$data.user.address_2,
                                            sender_contact: self.$data.user.contact_mobile,
                                            sender_post_code: localStorage.getItem('post_code'),
                                            receiver: result.receiver,
                                            address_1: result.address,
                                            receiver_contact: result.contact,
                                            post_code: result.post_code,
                                            custom_number: result.custom_id,
                                            seller_type: result.seller_type,
                                            custom_type: result.custom_type,
                                            trade_type: result.trade_type,
                                            note: result.message,
                                            forwarder_id: 4,
                                            value: 0,
                                            list: [],

                                        };

                                        if(result.order_number != undefined && result.order_number.length > 0) {
                                            item.order_number = result.order_number;
                                        }
                                        if(result.memo1 != undefined && result.memo1.length > 0) {
                                            item.memo1 = result.memo1;
                                        }
                                        if(result.memo2 != undefined && result.memo2.length > 0) {
                                            item.memo2 = result.memo2;
                                        }
                                        if (result.who_pays_tax != undefined && (result.who_pays_tax == 1 || result.who_pays_tax == 2)) {
                                            item.who_pays_tax = result.who_pays_tax;
                                        }
                                        if (result.who_pays_inspection != undefined && (result.who_pays_inspection == 1 || result.who_pays_inspection == 2)) {
                                            item.who_pays_inspection = result.who_pays_inspection;
                                        }
                                        if (item.post_code.length == 4) {
                                            item.post_code = "0" + item.post_code;
                                        }
                                        if (result.amount == undefined || result.amount == "") {
                                            item.ct = 1;
                                        } else {
                                            item.ct = result.amount;
                                        }
                                        // var totalValue = 0;
                                        // var itemList = [];
                                        list.push(item);
                                    }
                                    let itemIndex = list.length -1;
                                    if(itemIndex < 0) {
                                        self.showModal("에러", "첫 송장 데이터에 수취인과 주소가 있는지 확인해주세요");
                                        return;
                                    }


                                    for (var k = 1; k <= 5; k++) {
                                        // var productKey = "item" + k;
                                        // var amountKey = "amount" + k;
                                        // var hsCodeKey = "hscode" + k;
                                        //var
                                        console.log("item" + k);
                                        console.log("item " + k + " " + result["item" + k].length);



                                        if(result["item" + k] === null || result["item" + k].length === 0) {
                                          continue;
                                        }

                                        // console.log("amount " + result["amount" + k]);
                                        // console.log("hscode " + result["hscode" + k]);
                                        if(result["item" +k].length > 0 &&
                                            (result["amount"+k] == "" || result["amount"+k] == 0 || isNaN(result["amount" + k]) ||
                                                result["value" + k] == undefined ||  result["value" + k].length == 0 || isNaN(result["value" + k]) ) ) {
                                            self.showModal("에러", "수취인 " + list[itemIndex].receiver + " 품목 " + k +": " +  result["item" +k] + " 수량 및 단가를 확인해주세요");
                                            return;
                                        }

                                        if(result["hscode"+k] === undefined || result["hscode"+k] === null || result["hscode"+k].toString().length !== 6 ) {
                                          self.showModal("에러", "수취인 " + list[itemIndex].receiver + " 품목 " + k +": " +  result["item" +k] + " HSCODE: " + result["hscode"+k] +  " 6자리 HS Code를 입력해주세요");
                                          return;
                                        }
                                        if (result["item" + k].length > 0 && result["amount" + k] > 0 && result["hscode" + k].toString().length > 0) {
                                            if(result["amount" + k] == undefined || result["amount" + k].length == 0 || isNaN(result["amount" + k]) == true || result["amount" + k] % 1 !== 0 ) {
                                                self.showModal("에러", "수취인 " + list[itemIndex].receiver + " 품목수량 " + k +":   정수가 아닙니다." );
                                                return;
                                            }
                                            if(result["value" + k] == undefined ||  result["value" + k].length == 0 || isNaN(result["value" + k])) {
                                                self.showModal("에러", "수취인 " + list[itemIndex].receiver + " 품목단가 " + k +" 를 확인 해주세요." );
                                                return;
                                            }
                                            if(result["item" + k] != null && result["item" + k] != undefined && result["item" + k].length > 0 && (result["item" + k].includes("'") || result["item" + k].includes('"'))) {
                                                self.showModal("에러", "수취인 " + list[itemIndex].receiver + " 물품 " + k +":  특수문자는 사용 불가능합니다." );
                                                return;
                                            }
                                            if(result["brand" + k] != null && result["brand" + k] != undefined && result["brand" + k].length > 0 && (result["brand" + k].includes("'") || result["brand" + k].includes('"'))) {
                                                self.showModal("에러", "수취인 " + list[itemIndex].receiver + " 브랜드 " + k +":  특수문자는 사용 불가능합니다." );
                                                return;
                                            }
                                            if(result["origin_country" + k] != null && result["origin_country" + k] != undefined && result["origin_country" + k].length > 0 && (result["origin_country" + k].includes("'") || result["origin_country" + k].includes('"'))) {
                                                self.showModal("에러", "수취인 " + list[itemIndex].receiver + " 원산지 " + k +":  특수문자는 사용 불가능합니다." );
                                                return;
                                            }
                                            if(result['hscode' + k].toString().length !== 6) {
                                              self.showModal("에러", "수취인 " + list[itemIndex].receiver + " HS Code: " + result['hscode' + k].toString() +  ". HSCode 는 6자리입니다.");
                                              return;
                                            }
                                            console.log("here");
                                            let unitValue = parseFloat(result["value" + k]);

                                            console.log(JSON.stringify(result["item" +k]));

                                            result["item" +k] = escapeSpecialCharacters(result["item" +k])
                                            result["brand" +k] = escapeSpecialCharacters(result["brand" +k])
                                            result["origin_country" +k] = escapeSpecialCharacters(result["origin_country" +k])

                                            if(result["url"+k] !== undefined) {
                                              result["url"+k] = escapeSpecialCharacters(result["url" +k])

                                            } else {
                                              result["url"+k] = result["brand" +k];
                                            }
                                            if(result["brand"+k] !== undefined && result["brand"+k].length > 0) {
                                              if(result["brand"+k].length === 0) {
                                                self.showModal("에러", "수취인 " + list[itemIndex].receiver + " 브랜드 명은 필수 사항입니다.");
                                                return;
                                              }
                                            }
                                            var good = {
                                                product: result["item" + k].toUpperCase(),
                                                brand: result["brand" + k].toUpperCase(),
                                                site_url: result["url" + k].toUpperCase(),
                                                hs_code: result["hscode" + k].toString(),
                                                amount: result["amount" + k],
                                                value: unitValue,
                                                origin_country: result["origin_country" + k].toUpperCase(),
                                            };
                                            console.log("GOOD");
                                            console.log(good);
                                            list[itemIndex].value += unitValue * parseInt(result["amount" + k]);
                                            // good["liquid"] = 0;
                                            // if (result["liquid" + k].length > 0) {
                                            //     good["liquid"] = result["liquid" + k];
                                            // }
                                            console.log(good);
                                            list[itemIndex].list.push(good);
                                        }
                                    }



                                }
                                for(let i = 0 ; i < list.length ; i++) {
                                    list[i].list = JSON.stringify(list[i].list);
                                }
                                // return;
                                self.createList(list);

                            }
                            reader.readAsArrayBuffer(f);


                        });
                    }
                }
            },
            addFile(e) {
                this.$data.dropEnabled = false;
                var self = this;
                e.stopPropagation();
                e.preventDefault();
                let droppedFiles = e.dataTransfer.files;
                console.log("Add File");
                console.log(droppedFiles);
                if (!droppedFiles) return;
                // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
                ([...droppedFiles]).forEach(f => {

                    var reader = new FileReader(),
                        name = f.name;

                    reader.onload = function (e) {
                        var results;
                        var data = e.target.result;


                        var fixedData = self.fixdata(data),
                            workbook = XLSX.read(btoa(fixedData), {type: 'base64'}),
                            firstSheetName = workbook.SheetNames[0],
                            worksheet = workbook.Sheets[firstSheetName];
                        self.$data.state.headers = self.get_header_row(worksheet);
                        results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                        //self.$data.state.tickets=results;
                        console.log("Result");
                        //console.log(results);
                        var list = [];
                        var dispatchDate = '';

                        for (var i = 1; i < results.length; i++) {
                            var result = results[i];
                            console.log("index " + i);
                            console.log(result);
                            console.log("dispatchDate " + result.dispatch_date + " length " + result.dispatch_date.length);
                            if (result.dispatch_date > 4000) {
                                dispatchDate = self.convertExcDateToString(result.dispatch_date);
                            } else if (result.dispatch_date.length > 0) {
                                console.log("dispatchDate length " + result.dispatch_date.length);
                                if (result.dispatch_date.length == 10) {
                                    dispatchDate = result.dispatch_date;
                                }
                            }
                            if (result.seller_type == "") {
                                result.seller_type = "2";
                            }
                            if (result.trade_type == "") {
                                result.trade_type = "A";
                            }
                            if (result.custom_type == "") {
                                result.custom_type = "목";
                            }

                            let item = {
                                code: self.$data.user.code,
                                customer_id: self.$data.user.id,
                                dispatch_date: dispatchDate,//self.convertExcDateToString(dispatchDate),
                                sender: self.$data.user.title,
                                sender_address_1: self.$data.user.address_1,
                                sender_address_2: self.$data.user.address_2,
                                sender_contact: self.$data.user.contact_mobile,
                                sender_post_code: localStorage.getItem('post_code'),
                                receiver: result.receiver,
                                address_1: result.address,
                                receiver_contact: result.contact,
                                post_code: result.post_code,
                                custom_number: result.custom_id,
                                seller_type: result.seller_type,
                                custom_type: result.custom_type,
                                trade_type: result.trade_type,
                                note: result.message,
                                forwarder_id: 4,
                                list: '',

                            };
                            var totalValue = 0;
                            var itemList = [];
                            for (var k = 1; k <= 5; k++) {
                                var productKey = "item" + k;
                                var amountKey = "amount" + k;
                                var hsCodeKey = "hscode" + k;
                                //var
                                console.log("item" + k);
                                console.log("item " + k + " " + result["item" + k].length);
                                console.log("amount " + result["amount" + k]);
                                console.log("hscode " + result["hscode" + k]);
                                if (result["item" + k].length > 0 && result["amount" + k] > 0 && result["hscode" + k] !== null && result["hscode" + k].toString().length > 0) {
                                    console.log("here");
                                    if(result["hscode" + k].toString().length !== 6) {
                                      self.showModal("ERROR", "현재 HSCODE는 " + result["hscode" + k].toString() + "입니다. HS code 는 6자리입니다. 확인하시고 다시 입력해주세요");
                                      return;
                                    }
                                    var good = {
                                        product: result["item" + k].toUpperCase(),
                                        brand: result["brand" + k].toUpperCase(),
                                        site_url: result["brand" + k].toUpperCase(),
                                        hs_code: result["hscode" + k].toString(),
                                        amount: result["amount" + k],
                                        value: result["value" + k],
                                        origin_country: result["origin_country" + k].toUpperCase(),
                                    };
                                    totalValue += parseInt(result["value" + k]);
                                    // good["liquid"] = 0;
                                    // if (result["liquid" + k].length > 0) {
                                    //     good["liquid"] = result["liquid" + k];
                                    // }
                                    console.log(good);
                                    itemList.push(good);
                                }
                            }
                            item["list"] = JSON.stringify(itemList);
                            item["value"] = totalValue;
                            console.log(item);
                            list.push(item);


                        }
                        self.createList(list);

                    }
                    reader.readAsArrayBuffer(f);


                });
            },
            get_header_row: function (sheet) {
                var headers = [], range = XLSX.utils.decode_range(sheet['!ref']);
                //range.s.r = 2;//XLSX.utils.decode_row("3");
                var C, R = range.s.r; /* start in the first row */
                for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
                    var cell = sheet[XLSX.utils.encode_cell({c: C, r: R})] /* find the cell in the first row */
                    var hdr = "UNKNOWN " + C; // <-- replace with your desired default
                    if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
                    headers.push(hdr);
                }
                return headers;
            },
            fixdata: function (data) {
                var o = "", l = 0, w = 10240;
                for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
                o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
                return o;
            },
            workbook_to_json: function (workbook) {
                var result = {};
                workbook.SheetNames.forEach(function (sheetName) {
                    var roa = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
                    if (roa.length > 0) {
                        result[sheetName] = roa;
                    }
                });
                return result;
            },
            backHandler: function () {
                console.log("Main back pressed");
                if (this.$data.newItem != false) {
                    this.$data.newItem = false;
                    return;
                }

            },

            async showModal (title, message) {
                console.log("show modal " + title + " : " + message);
                this.$modal.show('dialog', {
                    title: title,
                    text: message,
                    buttons: [
                        {title: 'Close'}
                    ]
                })
                return;
            },
            onCountrySelected: function () {
                console.log("onCountrySelected");
                if (this.$data.newItem == false) {
                    return;
                }
                console.log("Selected " + this.$data.newItem.origin_country);
                for (var i = 0; i < this.$data.countries.length; i++) {
                    if (this.$data.countries[i].title == this.$data.newItem.origin_country) {
                        if (this.$data.countries[i].val == 1) {
                            this.$data.newItem.fta = 'FTA';
                        } else {
                            break;
                        }
                        return;
                    }
                }
                this.$data.newItem.fta = '';
            },
            getForwarderString: function (id) {
                for (var i = 0; i < this.$data.forwarders.length; i++) {
                    if (this.$data.forwarders[i].id == id) {
                        return this.$data.forwarders[i].title;
                    }
                }
                return '';
            },
            ftaString: function () {
                if (this.$data.newItem == false) {
                    return '';
                }
                for (var i = 0; i < this.$data.countries.length; i++) {
                    if (this.$data.countries[i].title == this.$data.newItem.origin_country) {
                        return 'FTA';
                    }
                }
                return '';
            },
            getCvList: function() {
                if(this.$data.selectedItems.length > 0) {
                    let zipCode = this.$data.items[this.$data.selectedItems[0]].post_code;
                    if(zipCode.includes(" ")) {
                        zipCode = zipCode.replace(" ", "");
                    }
                    let address = this.$data.items[this.$data.selectedItems[0]].address_1;
                    if (this.$data.items[this.$data.selectedItems[0]].address_2.length > 0) {
                        address += ' ' + this.$data.items[this.$data.selectedItems[0]].address_2;
                    }
                    console.log("printItem zipCode = " + zipCode);
                    console.log("printItem address = " + address);

                    let self = this;
                    this.$data.isLoading = true;
                    getDepotCode(zipCode, address)
                        .then(function(data) {
                            self.$data.isLoading = false;
                            if (data.cmmMsgHeader.successYN == 'Y') {
                                self.$data.items[self.$data.selectedItems[0]].code_list = JSON.stringify(data.delivAreaCdList);
                                let dataToPost = {
                                    id: self.$data.items[self.$data.selectedItems[0]].id,
                                    code_list: JSON.stringify(data.delivAreaCdList)
                                };
                                let postData = {
                                    "table": "item_table",
                                    "data": dataToPost,
                                };
                                self.$data.isLoading = true;
                                axios.post(process.env.APP_URL + 'api/update.php', postData)
                                    .then(response => {
                                        self.$data.isLoading = false;
                                        console.log(response);
                                        let rd = response.data;
                                        if (rd.success == true) {
                                            //self.$data.items.splice(index, 1);
                                            self.$data.selectedItems.splice(0,1);
                                            self.getCvList();
                                        } else {

                                            //self.showModal("ERROR", data.message);
                                        }
                                    })
                                    .catch(error => {
                                        self.$data.isLoading = false;
                                        //self.showModal("ERROR", error);
                                    })

                            }
                        })
                        .catch(function(err) {
                            console.log("Getting deport code error" + err);
                            if(err.response != undefined) {
                                console.log(err.response);
                            }
                            self.$data.isLoading = false;
                        })
                }
            },
            createList: function (list) {
                console.log("createList");
                var data = {
                    "list": list
                }
                var self = this;
                this.$data.selectedItems = [];
                var url = process.env.APP_URL + 'api/create_items.php';
                axios.post(url, data)
                    .then(response => {
                        var data = response.data;
                        console.log(data);
                        if (data.success) {
                            var items = data.items;
                            for (var i = 0; i < items.length; i++) {
                                items[i].list = items[i].list.replace("\n", "");
                                items[i].list = JSON.parse(items[i].list);
                                self.$data.items.push(items[i]);
                                self.$data.selectedItems.push(self.$data.items.length-1);
                            }
                            self.getCvList();

                        } else {
                            console.log("Error " + data.message);
                        }
                    })
                    .catch(error => {
                        console.log("create list error " + error);
                        if(error.response != undefined) {
                            console.log(error.response);
                        }
                    });
            },
            isTodayDispatchDate: function(date) {
                let today = millisToDate(new Date().getTime(), '-');
                // console.log("Compare " + date + " " + today);
                if(date === today) {
                    return true;
                }
                return false;
            },
            checkChangeable: function(index, newState) {
                let self = this;
                getItem(this.$data.items[index].id)
                    .then(function(data) {
                        if(data.success == true) {
                            if(data.item.state <= 0) {
                                self.onChangeState(index, newState);
                            } else {
                                self.showModal("", "이미 접수된 송장입니다. 수정을 위해서는 런던우체국으로 연락을 주십시요");
                                return;
                            }
                        } else {
                            self.showModal("", "송장을 찾을 수 앖습니다. 수정을 위해서는 런던우체국으로 연락을 주십시요");
                            return;
                        }
                    })
                    .catch(function(err) {
                        let errMsg = err;
                        if(err.response != undefined) {
                            errMsg += ' 에레 내용 [' + err.response + ']';
                        }
                        self.showModal("에러발생", "에러가 발생했습니다. " + errMsg);
                    })
            },
            onChangeState: function(index, newState) {
                let dataToPost = {
                    id: this.$data.items[index].id,
                    state:newState
                };
                let postData = {
                    "table": "item_table",
                    "data": dataToPost,
                };
                let self = this;
                self.$data.isLoading = true;
                axios.post(process.env.APP_URL + 'api/update.php', postData)
                    .then(response => {
                        self.$data.isLoading = false;
                        let data = response.data;
                        if (data.success == true) {
                            //self.$data.items = data.items;
                            for (let i = 0; self.$data.items.length; i++) {
                                if(self.$data.items[i].id == data.item.id) {
                                    if(data.item.state != self.$data.filter.state) {
                                        self.$data.items.splice(i, 1);
                                    } else {
                                        data.item.list = JSON.parse(data.item.list);
                                        self.$data.items.splice(i, 1, data.item);
                                    }
                                    return;
                                }

                            }
                        } else {

                        }
                    })
                    .catch(err=>{

                    })
            },
            stateChange: function(newState) {
                this.$data.filter.state = newState;
                this.$data.filter.awb = "";
                this.$data.filter.receiver = "";
                this.getPendingList();
            },
            getPendingList: function () {
                var self = this;
                this.$data.items = [];
                this.$data.isLoading = true;
                var url = process.env.APP_URL + 'api/get_items.php?customer_id=' + this.$data.user.id;
                if (this.$data.filter.awb.length > 0) {
                    url += '&awb=' + this.$data.filter.awb;
                } else if (this.$data.filter.receiver.length > 0) {
                    url += '&receiver=' + this.$data.filter.receiver;
                }
                url += '&state=' + this.$data.filter.state;

                axios.get(url)
                    .then(response => {
                        self.$data.isLoading = false;
                        // console.log("Get Pending");
                        // console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            self.$data.items = data.items;
                            // console.log("HERE 1")
                            for (var i = 0; self.$data.items.length; i++) {
                                // console.log("HERE 2");
                                // console.log(JSON.stringify(self.$data.items[i].list));
                                if(self.$data.items[i].list.match(/\r/g)) {
                                    console.log("ashdjadsas");
                                    self.$data.items[i].list = self.$data.items[i].list.replace(/\r/g,"");
                                }
                                if(self.$data.items[i].list.match(/\n/g)) {
                                  console.log("LINEBREAK FOUND");
                                  self.$data.items[i].list = self.$data.items[i].list.replace(/\n/g,"");
                                }
                                if(self.$data.items[i].list.match("\\n")) {
                                  console.log("LINEBREAK FOUND");
                                  self.$data.items[i].list = self.$data.items[i].list.replace(/\\n/g,"");
                                }

                                if(self.$data.items[i].list.match("\\t")) {
                                  console.log("TAB FOUND");
                                  self.$data.items[i].list = self.$data.items[i].list.replace(/\t/g,"");
                                }


                                self.$data.items[i].list = JSON.parse(self.$data.items[i].list);
                                // console.log(self.$data.items[i]);
                            }
                        } else {

                        }
                    })
                    .catch(error => {
                        self.$data.isLoading = false;
                    });
            },
            getHeldList: function () {
                let self = this;
                this.$data.items = [];
                let url = process.env.APP_URL + 'api/get_items.php?customer_id=' + this.$data.user.id;
                if (this.$data.filter.awb.length > 0) {
                    url += '&awb=' + this.$data.filter.awb;
                } else if (this.$data.filter.receiver.length > 0) {
                    url += '&receiver=' + this.$data.filter.receiver;
                } else {
                    url += '&state=-1';
                }
                axios.get(url)
                    .then(response => {
                        console.log("Get Held List");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            self.$data.items = data.items;
                            for (let i = 0; self.$data.items.length; i++) {
                                self.$data.items[i].list = JSON.parse(self.$data.items[i].list);
                            }
                        } else {

                        }
                    })
                    .catch(error => {

                    });
            },
            getForwarderList: function () {
                var self = this;
                console.log("getForwarderList");
                var url = process.env.APP_URL + 'api/get_customer_meta.php?customer_id=' + this.$data.user.id;
                axios.get(url)
                    .then(response => {
                        console.log(response);
                        var data = response.data;
                        if (data.success) {
                            self.$data.forwarders = data.forwarders;
                            console.log("forwarders set");
                            console.log(self.$data.forwarders);
                            self.$data.countries = data.countries;
                            self.$data.hsCodes = data.hs_code;
                            self.$data.hsCodes.sort(function (a, b) {
                                return b.val2 - a.val2;
                            })
                        }
                    })
                    .catch(error => {

                    });
            },
            getDescriptionList: function (list) {
                let text = "";
                // console.log("getDescriptionList");
                // console.log(list);
                if (list != undefined && list.length > 0) {

                    // console.log(list[0]);
                    if (list[0].origin_country != '' && list[0].origin_country.length > 0) {
                        text += list[0].origin_country + " ";
                    }
                    if (list[0].brand != '' && list[0].brand.length > 0) {
                        text += "[" + list[0].brand + "] ";
                    }
                    text += list[0].product;

                    if (list.length > 1) {
                        let count = 0;
                        for (let i = 1; i < list.length; i++) {
                            if (list[i].amount > 0) {
                                count++;
                            }
                        }
                        if (count > 0)
                            text += " 외 " + count + "건";
                    }
                }
                return text;
            },
            editItem: function (index) {
                let self = this;
                getItem(this.$data.items[index].id)
                    .then(function(data) {
                        if(data.success == true) {
                            data.item.list = JSON.parse(data.item.list);
                            self.$data.items.splice(index, 1, data.item);
                            self.$data.newItem = JSON.parse(JSON.stringify(self.$data.items[index]));
                            if (self.$data.newItem.list.length == 0) {
                                self.$data.newItem.list = [];
                            }

                        } else {
                            self.showModal("", "송장을 찾을 수 앖습니다. 수정을 위해서는 런던우체국으로 연락을 주십시요");
                            return;
                        }
                    })
                    .catch(function(err) {
                        let errMsg = err;
                        if(err.response != undefined) {
                            errMsg += ' 에레 내용 [' + err.response + ']';
                        }
                        self.showModal("에러발생", "에러가 발생했습니다. " + errMsg);
                    })


            },
            deleteItem: function (index) {
                var message = "송장 " + this.$data.items[index].awb + "를 지우시겠습니까?";

                var self = this;
                this.$modal.show('dialog', {
                    title: "DELETE ITEM",
                    text: message,
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '삭제',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.deleteItemCheck(index);
                            }
                        },
                    ]
                })
                return;
            },
            deleteItemCheck: function(index) {
                let self = this;
                getItem(this.$data.items[index].id)
                    .then(function(data) {
                        if(data.success == true) {
                            if(data.item.state <= 0) {
                                self.deleteItemConfirm(index);
                            } else {
                                self.showModal("", "이미 접수된 송장입니다. 수정을 위해서는 런던우체국으로 연락을 주십시요");
                                return;
                            }
                        } else {
                            self.showModal("", "송장을 찾을 수 앖습니다. 수정을 위해서는 런던우체국으로 연락을 주십시요");
                            return;
                        }
                    })
                    .catch(function(err) {
                        let errMsg = err;
                        if(err.response != undefined) {
                            errMsg += ' 에레 내용 [' + err.response + ']';
                        }
                        self.showModal("에러발생", "에러가 발생했습니다. " + errMsg);
                    })
            },
            deleteItemConfirm: function (index) {

                var data = {
                    id: this.$data.items[index].id,
                    deleted: 1,
                    deleted_time: getTimeStamp(),
                    deleted_by: '업체'

                };
                var postData = {
                    "table": "item_table",
                    "data": data,
                };
                let self = this;
                axios.post(process.env.APP_URL + 'api/update.php', postData)
                    .then(response => {
                        console.log(response);
                        var data = response.data;
                        if (data.success == true) {
                            self.$data.items.splice(index, 1);
                        } else {
                            self.showModal("ERROR", data.message);
                        }
                    })
                    .catch(error => {
                        self.showModal("ERROR", error);
                    })
            },
            deleteSelected: function() {
                let list = [];
                for (let i = 0; i < this.$data.selectedItems.length; i++) {

                    let item = {
                        id: this.$data.items[this.$data.selectedItems[i]].id,
                        deleted: 1,
                        deleted_time: getTimeStamp(),
                        deleted_by: '업체'

                    };
                    list.push(item);
                }
                if (list.length == 0) {
                    console.log("No List to assign");
                    return;
                }
                let data = {
                    "table": "item_table",
                    "list": list,
                };
                let self = this;
                axios.post(process.env.APP_URL + 'api/update_items.php', data)
                    .then(response => {
                        console.log(response);
                        let data = response.data;
                        if (data.success == true) {
                            console.log("Successful update");
                            for (let i = 0; i < data.items.length; i++) {
                                for (let j = 0; j < self.$data.items.length; j++) {
                                    if(data.items[i].id == self.$data.items[j].id) {
                                        self.$data.items.splice(j, 1);
                                    }
                                }
                            }

                        } else {
                            self.showModal("ERROR", "Failed to delete " + data.message);
                        }
                        self.$data.selectedItems = [];
                    })
                    .catch(error => {

                    })
            },
            validateGoods: function () {
                if (this.$data.newItem == false) {
                    return false;
                }
                if (this.$data.newItem.list.length == 0) {
                    this.showModal("ERROR", "물품을 추가해주세요");
                    return false;
                }

                console.log(this.$data.newItem.list);
                for (let i = this.$data.newItem.list.length - 1; i >= 0; i--) {

                    if (this.$data.newItem.list[i].amount < 1 && i >= 5) {
                        this.$data.newItem.list.splice(i, 1);

                    }
                }
                if (this.$data.newItem.list.length == 0) {
                    this.showModal("ERROR", "물품을 추가해주세요");
                    return false;
                }
                this.countTotalValue();
                return true;
            },
            countTotalValue: function () {
                if (this.$data.newItem == false) {
                    return;
                }
                this.$data.newItem.value = 0;
                if (this.$data.newItem.list.length == 0) {
                    return;
                }
                for (let i = 0; i < this.$data.newItem.list.length; i++) {
                    this.$data.newItem.value += parseFloat(this.$data.newItem.list[i].value) * parseInt(this.$data.newItem.list[i].amount);
                }
                this.$data.newItem.value = parseFloat(this.$data.newItem.value.toFixed(2));
            },
            openNewItem: function () {
                console.log("openNewItem");
                console.log(this.$data.user);
                this.$data.newItem = {
                    id: 0,
                    customer_id: this.$data.user.id,
                    code: this.$data.user.code,
                    // list: [
                    //     {
                    //         product: '',
                    //         brand: '',
                    //         amount: 1,
                    //         value: 0,
                    //         origin_country: '',
                    //         liquid: 0,
                    //     },
                    // ],
                    sender: this.$data.user.title,
                    sender_post_code: this.$data.user.post_code,
                    sender_address_1: this.$data.user.address_1,
                    sender_address_2: this.$data.user.address_2,
                    sender_contact: this.$data.user.contact_mobile,
                    ct: 1,
                    order_number: '',
                    deliery_company_id: 0,
                    awb: "",
                    receiver: "",
                    receiver_contact: "",
                    email: "",
                    custom_number: "P",
                    who_pays_tax: 0,
                    who_pays_inspection: 0,
                    national_id: "",
                    post_code: "",
                    address_1: "",
                    address_2: "",
                    value: 0,
                    forwarder_id: 4,
                    forwarder_string: "CWAY",
                    dispatch_date: "0000-00-00",
                    custom_type: "목",
                    trade_type: "A",
                    seller_type: 4,
                    base_price: this.$data.user.base_price,
                    add_price: this.$data.user.price,
                    list: [],
                    state: 0,
                };
                console.log("New Item");
                console.log("BP " + this.$data.newItem.base_price);
                console.log("AP " + this.$data.newItem.add_price);
                this.onAddGood();
                this.onAddGood();
                this.onAddGood();
                this.onAddGood();
                this.onAddGood();
            },
            onAddGood: function () {
                var newGood = {
                    product: "",
                    brand: "",
                    site_url: "",
                    hs_code: -1,
                    origin_country: "",
                    amount: 0,
                    value: 0,
                    liquid: 0,
                };
                this.$data.newItem.list.push(newGood);
            },
            closeNewItemForm: function () {
                this.$data.newItem = false;

            },
            calculateTotalValue: function() {
                console.log("calculateValue");
                if(this.$data.newItem.list.length == 0) {
                    this.$data.newItem.value = 0;
                    return;
                }

                let totalValue = 0;
                for(let i = 0 ; i < this.$data.newItem.list.length ; i++) {
                    if(this.$data.newItem.list[i].amount== "" || this.$data.newItem.list[i].value == '') {

                        continue;
                    }
                    console.log(i + " item " + this.$data.newItem.list[i].amount + " " + this.$data.newItem.list[i].value);
                    totalValue += (Number(this.$data.newItem.list[i].amount)*parseFloat(this.$data.newItem.list[i].value));
                }
                this.$data.newItem.value = parseFloat(totalValue.toFixed(2));
                console.log("total Value = " + this.$data.newItem.value);
            },
            getTodayData: function () {
                var myDate = new Date();
                var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
                var date = ('0' + myDate.getDate()).slice(-2);
                var year = myDate.getFullYear();
                var formattedDate = year + '-' + month + '-' + date;
                return formattedDate;
            },
            verifySendDate: function () {
                if (this.$data.newItem.dispatch_date.length == 0 || this.$data.newItem.dispatch_date == '0000-00-00') {
                    this.showModal("ERROR", "보내는 날짜를 선택해주세요");
                    return;
                }

                if (this.$data.newItem.dispatch_date < this.getTodayData()) {
                    this.showModal("ERROR", "불가능한 날짜입니다.");
                    this.$data.newItem.dispatch_date = '0000-00-00';
                    return;
                }
            },
            verifyItemForm: function () {
                if (this.$data.newItem.sender.length < 1) {
                    this.showModal("ERROR", "보내는 사람을 입력해주세요");
                    return false;
                }
                if (this.$data.newItem.code.length != 4) {
                    this.showModal("ERROR", "Station Code를 입력해주세요");
                    return false;
                }
                // if (this.$data.newItem.sender_post_code.length < 5) {
                //     this.showModal("ERROR", "Sender's Post code Required");
                //     return false;
                // }
                if (this.$data.newItem.sender_address_1.length < 1) {
                    this.showModal("ERROR", "Address Required");
                    return false;
                }
                if (this.$data.newItem.sender_address_2.length < 1) {
                    this.showModal("ERROR", "Address Detail Required");
                    return false;
                }
                if (this.$data.newItem.sender_contact.length < 1) {
                    this.showModal("ERROR", "Address Detail Required");
                    return false;
                }

                if (this.$data.newItem.receiver.length < 2) {
                    this.showModal("ERROR", "Name Required");
                    return false;
                }
                if (this.$data.newItem.receiver_contact.length < 10) {
                    this.showModal("ERROR", "Phone number Required");
                    return false;
                }
                console.log("Update ITem ");
                console.log(this.$data.newItem);
                if (this.$data.newItem.post_code.length < 5) {
                    this.showModal("ERROR", "Post code Required");
                    return false;
                }
                if (this.$data.newItem.address_1.length < 10) {
                    this.showModal("ERROR", "Address Required");
                    return false;
                }
                // if (this.$data.newItem.address_2.length < 1) {
                //     this.showModal("ERROR", "Address Detail Required");
                //     return false;
                // }
                if (this.$data.newItem.value.length < 0) {
                    this.showModal("ERROR", "Value Required");
                    return false;
                }
                if (this.$data.newItem.forwarder_id <= 0) {
                    this.showModal("ERROR", "Select Forwarder");
                    return false;
                }
                if (this.$data.newItem.dispatch_date.length == 0 || this.$data.newItem.dispatch_date == '0000-00-00') {
                    this.showModal("ERROR", "Select Date to Send");
                    return false;
                }
                this.$data.newItem.custom_number
                if (this.$data.newItem.custom_number.length < 0) {
                    this.showModal("ERROR", "개인통관번호를 입력하세요");
                    return false;
                }
                return this.validateGoods();
                //return true;
            },
            getDWItem: function () {
                console.log("getDWItem");
                const formData = new FormData();
                formData.append("user_id", this.$data.newItem.code);
                formData.append("user_key", "SS0611");
                formData.append("return_url", "https://api.utasco.net/api/dw_response_handler.php");
                formData.append("col_date", this.$data.newItem.dispatch_date);
                formData.append("shipper_name", this.$data.newItem.sender);
                formData.append("shipper_addr", this.$data.newItem.sender_address_1);
                formData.append("shipper_city", this.$data.newItem.sender_address_2);
                formData.append("shipper_zipcode", this.$data.newItem.sender_post_code);
                formData.append("shipper_tel", this.$data.newItem.sender_contact);
                formData.append("consignee_kor_name", this.$data.newItem.receiver);
                formData.append("consignee_kor_zipcode", this.$data.newItem.post_code);
                formData.append("consignee_kor_addr1", this.$data.newItem.address_1);
                formData.append("consignee_kor_addr2", this.$data.newItem.address_2);
                formData.append("consignee_tel", this.$data.newItem.receiver_contact);
                formData.append("memo", "");
                formData.append("consignee_social_id", this.$data.newItem.custom_number);
                formData.append("goods_weight", "0.1");
                formData.append("goods_ct", "1");
                formData.append("goods_brand1", "Burberry");
                formData.append("goods_name1", "Scarf");
                formData.append("goods_img1", "");
                formData.append("goods_qty1", "1");
                formData.append("goods_price1", "130");
                formData.append("goods_amount1", "130");
                formData.append("hs_code1", "54");
                console.log(formData);
                axios.post("http://shipping.daewoonglobal.com/bill/bill_info.asp", formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                })
                    .then(response => {
                        console.log("Response");
                        console.log(response);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            submitNewItem: function () {
                console.log("submitNewItem");
                if (this.verifyItemForm() == false) {
                    return;
                }

                // this.getDWItem();
                // return;

                var item = {
                    "customer_id": this.$data.newItem.customer_id,
                    "sender": this.$data.newItem.sender,
                    "code": this.$data.newItem.code,
                    "sender_address_1": this.$data.newItem.sender_address_1,
                    "sender_address_2": this.$data.newItem.sender_address_2,
                    "sender_post_code": this.$data.newItem.sender_post_code,
                    "sender_contact": this.$data.newItem.sender_contact,
                    "dispatch_date": this.$data.newItem.dispatch_date,
                    "order_number": this.$data.newItem.order_number,
                    "receiver": this.$data.newItem.receiver,
                    "receiver_contact": this.$data.newItem.receiver_contact,
                    "email": this.$data.newItem.email,
                    "post_code": this.$data.newItem.post_code,
                    "address_1": this.$data.newItem.address_1,
                    "address_2": this.$data.newItem.address_2,
                    "ct": this.$data.newItem.ct,
                    "value": this.$data.newItem.value,
                    "forwarder_id": this.$data.newItem.forwarder_id,
                    "forwarder_string": this.getForwarderString(this.$data.newItem.forwarder_id),
                    "custom_number": this.$data.newItem.custom_number,
                    "who_pays_tax": this.$data.newItem.who_pays_tax,
                    "who_pays_inspection": this.$data.newItem.who_pays_inspection,
                    "national_id": this.$data.newItem.national_id,
                    "custom_type": this.$data.newItem.custom_type,
                    "trade_type": this.$data.newItem.trade_type,
                    "seller_type": this.$data.newItem.seller_type,
                    "list": JSON.stringify(this.$data.newItem.list),
                    "note": this.$data.newItem.note,
                    "code_list":'',
                    // "base_price": this.$data.newItem.base_price,
                    // "add_price": this.$data.newItem.add_price,
                };

                console.log(item);
                //return;
                let zipCode = item.post_code;
                if(zipCode.includes(" ")) {
                    zipCode = zipCode.replace(" ", "");
                }
                let address = item.address_1;
                if (item.address_2.length > 0) {
                    address += ' ' + item.address_2;
                }
                console.log("printItem zipCode = " + zipCode);
                console.log("printItem address = " + address);

                var self = this;


                this.$data.isLoading = true;
                getDepotCode(zipCode, address)
                    .then(function(dcdata) {
                        self.$data.isLoading = false;
                        if (dcdata.cmmMsgHeader.successYN == 'Y') {

                            item.code_list = JSON.stringify(dcdata.delivAreaCdList);

                        }
                        self.updateItem(item);
                    })
                    .catch(function(err) {
                        self.$data.isLoading = false;
                        console.log("ERR to update " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                        self.updateItem(item);
                    })
            },
            updateItem: function(item) {
                let self = this;
                self.$data.isLoading = true;
                if (self.$data.newItem.id == 0) {
                    axios.post(process.env.APP_URL + 'api/add_new_item.php', item)
                        .then(response => {
                            self.$data.isLoading = false;
                            console.log(response);
                            let data = response.data;
                            if (data.success == true) {
                                data.item.list = JSON.parse(data.item.list);
                                self.$data.items.push(data.item);
                                self.$data.newItem = false;
                            } else {
                                self.showModal("ERROR", "Failed to create new AWB " + data.message);
                            }
                        })
                        .catch(error => {
                            self.$data.isLoading = false;
                            self.showModal("ERROR", "죄송합니다. 생성 실패했습니다. " + error);
                        })
                } else if (self.$data.newItem.id > 0) {
                    item["id"] = self.$data.newItem.id;
                    let postData = {
                        "table": "item_table",
                        "data": item,
                    };
                    axios.post(process.env.APP_URL + 'api/update.php', postData)
                        .then(response => {
                            self.$data.isLoading = false;
                            console.log(response);
                            var data = response.data;
                            if (data.success == true) {
                                console.log("Successful update");
                                for (var i = 0; i < self.$data.items.length; i++) {
                                    if (self.$data.items[i].id == data.item.id) {
                                        self.$data.items[i] = data.item;
                                        self.$data.items[i].list = JSON.parse(data.item.list);
                                        break;
                                    }
                                }
                                console.log("Set newITem to false");
                                self.$data.newItem = false;
                            } else {
                                self.showModal("ERROR", "Failed to update " + data.message);
                            }
                        })
                        .catch(error => {
                            self.$data.isLoading = false;
                            self.showModal("ERROR", "죄송합니다. 업데이트 실패했습니다. " + error);
                        })
                }
            },
            onReceiverEntered: function() {
                console.log("Entered");
            },
            findReceiver: function () {
                console.log("Search " + this.$data.newItem.receiver);
                this.$data.existingReceivers = [];
                let self = this;
                let url = process.env.APP_URL + 'api/get_items.php?customer_id=' + this.$data.user.id;
                url += '&receiver=' + this.$data.newItem.receiver;
                axios.get(url)
                    .then(response => {
                        console.log("Get Pending");
                        console.log(response);

                        let data = response.data;
                        if (data.success == true) {
                            self.$data.existingReceivers = data.items;

                        } else {
                            self.showModal("Cannot find", self.$data.newItem.receiver + " 검색결과가 없습니다.")
                        }
                    })
                    .catch(error => {
                        self.showModal("ERROR", "에러가 발생했습니다 " + error);
                    });
            },
            onSelectFromReceiverList: function(index) {
                this.newItem.receiver = this.$data.existingReceivers[index].receiver;
                this.newItem.address_1 = this.$data.existingReceivers[index].address_1;
                this.newItem.address_2 = this.$data.existingReceivers[index].address_2;
                this.newItem.custom_number = this.$data.existingReceivers[index].custom_number;
                this.newItem.post_code = this.$data.existingReceivers[index].post_code;
                this.newItem.receiver_contact = this.$data.existingReceivers[index].receiver_contact;
                this.newItem.receiver_contact = this.$data.existingReceivers[index].receiver_contact;
                this.newItem.email = this.$data.existingReceivers[index].email;
                this.$data.existingReceivers = [];
            },
            closeReceiverSearchList: function() {
                console.log("Close list");
                this.$data.existingReceivers = [];
            },
            findAddress: function () {
                this.$data.showAddressFinder = true;
                var self = this;
                new daum.Postcode({
                    oncomplete: function (data) {
                        // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

                        // 각 주소의 노출 규칙에 따라 주소를 조합한다.
                        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
                        console.log(data);
                        var addr = ''; // 주소 변수
                        var extraAddr = ''; // 참고항목 변수

                        //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
                        if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
                            addr = data.roadAddress;
                        } else { // 사용자가 지번 주소를 선택했을 경우(J)
                            addr = data.jibunAddress;
                        }

                        // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
                        if (data.userSelectedType === 'R') {
                            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
                            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
                            if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
                                extraAddr += data.bname;
                            }
                            // 건물명이 있고, 공동주택일 경우 추가한다.
                            if (data.buildingName !== '') {
                                extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
                            }
                            // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
                            if (extraAddr !== '') {
                                extraAddr = ' (' + extraAddr + ')';
                            }
                            // 조합된 참고항목을 해당 필드에 넣는다.
                            //document.getElementById("sample2_extraAddress").value = extraAddr;

                        } else {
                            //document.getElementById("sample2_extraAddress").value = '';
                        }

                        // 우편번호와 주소 정보를 해당 필드에 넣는다.
                        self.$data.newItem.post_code = data.zonecode;
                        self.$data.newItem.address_1 = addr;
                        if (extraAddr !== '') {
                            self.$data.newItem.address_1 += extraAddr;
                        }
                        //self.$data.basketPageDeliveryInfoEdit = true;
                        //document.getElementById('sample2_postcode').value = data.zonecode;
                        //document.getElementById("sample2_address").value = addr;
                        // 커서를 상세주소 필드로 이동한다.
                        //document.getElementById("sample2_detailAddress").focus();

                        // iframe을 넣은 element를 안보이게 한다.
                        // (autoClose:false 기능을 이용한다면, 아래 코드를 제거해야 화면에서 사라지지 않는다.)
                        self.$data.showAddressFinder = false;
                        $("#finder-container").css('display', 'none');
                        $("#postcodeFinderLayer").css('display', 'none');

                    },
                    width: '100%',
                    height: '100%',
                    maxSuggestItems: 5
                }).embed(document.getElementById('postcodeFinderLayer'));

                // iframe을 넣은 element를 보이게 한다.
                $("#finder-container").css('display', 'block');
                $("#postcodeFinderLayer").css('display', 'block');
            },
            closeAddressFinder: function () {
                this.$data.showAddressFinder = false;
                $("#finder-container").css('display', 'none');
                $("#postcodeFinderLayer").css('display', 'none');
            },
            getFTADoc: function (id) {

                console.log("Search " + id);
                downloadFTADoc(id);
            },

            downloadForCustomerH: function () {
                var url = 'static/customer_form_horizontal.xlsx';
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "arraybuffer";

                var self = this;
                req.onload = function (e) {
                    var data = new Uint8Array(req.response);
                    var workbook = XLSX.read(data, {type: "array"});

                    /* DO SOMETHING WITH workbook HERE */
                    var worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    var test = XLSX.utils.sheet_to_json(worksheet);
                    console.log("TEst data");
                    console.log(test);
                    var results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                    console.log("Read data");
                    console.log(results);
                    var row = results[0];
                    var header = [];
                    for (var key in row) {
                        header.push(key);
                    }
                    var newList = [];
                    //newList.push(header);
                    for (var i = 0; i < self.$data.items.length; i++) {
                        var dataItem = self.$data.items[i];
                        let whoPaysFee = '수취인';
                        if(dataItem["who_pays_inspection"] == 2) {
                            whoPaysFee = '발송인';
                        }
                        var item = [dataItem["order_number"], dataItem["awb"], dataItem["dispatch_date"],
                            dataItem["sender"], dataItem["sender_contact"], dataItem["sender_post_code"], dataItem["sender_address_1"] + " " + dataItem["sender_address_2"],
                            dataItem["receiver"], dataItem["receiver_contact"], dataItem["receiver_contact"], dataItem["post_code"], dataItem["address_1"], "", dataItem["custom_number"], dataItem['memo'],
                            (dataItem["measured_weight"] / 100).toFixed(2), (dataItem["weight"] / 100).toFixed(2), dataItem["ct"], whoPaysFee, dataItem["memo1"], dataItem["memo2"]];


                        var list = self.$data.items[i].list;
                        for (var j = 0; j < list.length; j++) {
                            item.push(list[j].product);
                            item.push(list[j].amount);
                            item.push(list[j].value);
                            item.push(list[j].brand);
                            item.push(list[j].url);
                            item.push(list[j].hs_code);
                            item.push(list[j].origin_country);
                        }

                        newList.push(item);
                    }

                    XLSX.utils.sheet_add_aoa(worksheet, newList, {origin: -1});


                    var sheet = XLSX.utils.json_to_sheet(newList)

                    // A workbook is the name given to an Excel file
                    var wb = XLSX.utils.book_new() // make Workbook of Excel

                    // add Worksheet to Workbook
                    // Workbook contains one or more worksheets
                    XLSX.utils.book_append_sheet(wb, worksheet, 'sheet1') // sheetAName is name of Worksheet

                    // export Excel file
                    var fileName = "UTASCO-" + moment(new Date()).format("YYYYMMDD-hhmmss") + '.xlsx';
                    XLSX.writeFile(wb, fileName); // name of the file is book.xlsx
                }

                req.send();
                console.log("DW form");


            },
            downloadForCustomerV: function () {
                var url = 'static/customer_form_vertical.xlsx';
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "arraybuffer";

                var self = this;
                req.onload = function (e) {
                    var data = new Uint8Array(req.response);
                    var workbook = XLSX.read(data, {type: "array"});

                    /* DO SOMETHING WITH workbook HERE */
                    var worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    var test = XLSX.utils.sheet_to_json(worksheet);
                    console.log("TEst data");
                    console.log(test);
                    var results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                    console.log("Read data");
                    console.log(results);
                    var row = results[0];
                    var header = [];
                    for (var key in row) {
                        header.push(key);
                    }
                    var newList = [];
                    //newList.push(header);
                    for (var i = 0; i < self.$data.items.length; i++) {
                        var dataItem = self.$data.items[i];
                        let whoPaysFee = '수취인';
                        if(dataItem["who_pays_inspection"] == 2) {
                            whoPaysFee = '발송인';
                        }
                        var item = [dataItem["order_number"], dataItem["awb"], dataItem["dispatch_date"],
                            dataItem["sender"], dataItem["sender_contact"], dataItem["sender_post_code"], dataItem["sender_address_1"] + " " + dataItem["sender_address_2"],
                            dataItem["receiver"], dataItem["receiver_contact"], dataItem["receiver_contact"], dataItem["post_code"], dataItem["address_1"], "", dataItem["custom_number"], dataItem['note'],
                            (dataItem["measured_weight"] / 100).toFixed(2), (dataItem["weight"] / 100).toFixed(2), dataItem["ct"], whoPaysFee, dataItem["memo1"], dataItem["memo2"]];


                        var list = self.$data.items[i].list;
                        for (var j = 0; j < list.length; j++) {
                            if(j > 0) {
                                item = [
                                    "", "", "",
                                    "", "", "", "",
                                    "", "", "", "", "", "", "", "",
                                    "", "", "", "", "", ""];

                            }
                            item.push(list[j].product);
                            item.push(list[j].amount);
                            item.push(list[j].value);
                            item.push(list[j].brand);
                            item.push(list[j].url);
                            item.push(list[j].hs_code);
                            item.push(list[j].origin_country);
                            newList.push(item);
                        }


                    }

                    XLSX.utils.sheet_add_aoa(worksheet, newList, {origin: -1});


                    var sheet = XLSX.utils.json_to_sheet(newList)

                    // A workbook is the name given to an Excel file
                    var wb = XLSX.utils.book_new() // make Workbook of Excel

                    // add Worksheet to Workbook
                    // Workbook contains one or more worksheets
                    XLSX.utils.book_append_sheet(wb, worksheet, 'sheet1') // sheetAName is name of Worksheet

                    // export Excel file
                    var fileName = "UTASCO-" + moment(new Date()).format("YYYYMMDD-hhmmss") + '.xlsx';
                    XLSX.writeFile(wb, fileName); // name of the file is book.xlsx
                }

                req.send();
                console.log("DW form");


            },
            onProductEntered: function (index) {
                if (this.$data.newItem == false) {
                    return;
                }
                if (this.$data.newItem.list.length < index) {
                    return;
                }

                if (this.$data.newItem.list[index].product.length > 0) {
                    if (this.$data.newItem.list[index].amount == 0) {
                        this.$data.newItem.list[index].amount = 1;
                    }
                } else {
                    this.$data.newItem.list[index].amount = 0;
                }
                if (this.$data.newItem.list[index].product.length > 0) {
                    // if (this.$data.newItem.list[index].product.includes('"') || this.$data.newItem.list[index].product.includes("'")) {
                    //     this.showModal("에러", "특수문자는 사용할수 없습니다");
                        this.$data.newItem.list[index].product = this.$data.newItem.list[index].product.replace(/[^0-9a-zA-Z.()\- ]/g, "");


                    // }
                }
              if (this.$data.newItem.list[index].site_url !== null && this.$data.newItem.list[index].site_url.length > 0) {
                this.$data.newItem.list[index].site_url = this.$data.newItem.list[index].site_url.replace(/[^a-zA-Z0-9.()\- ]/g, "");
              }
            },
            checkBrandSpecialKey: function (index) {
                if (this.$data.newItem == false) {
                    return;
                }
                if (this.$data.newItem.list.length < index) {
                    return;
                }
                if (this.$data.newItem.list[index].brand.length > 0) {
                  // console.log(JSON.stringify(this.$data.newItem.list[index].brand));
                  this.$data.newItem.list[index].brand = this.$data.newItem.list[index].brand.replace(/[^0-9a-zA-Z.()\- ]/g, "");
                  // console.log(JSON.stringify(this.$data.newItem.list[index].brand));
                    // if (this.$data.newItem.list[index].brand.includes('"') || this.$data.newItem.list[index].brand.includes("'")) {
                    //     this.$data.newItem.list[index].brand = this.$data.newItem.list[index].brand.replace(/[^a-zA-Z ]/g, "");
                    //     //this.$data.newItem.list[index].brand.replace('"', "");
                    //     this.showModal("에러", "특수문자는 사용할수 없습니다");
                    //     return;
                    // }
                    // if(this.$data.newItem.list[index].brand.match("\\t")) {
                    //   this.$data.newItem.list[index].brand = this.$data.newItem.list[index].brand.replace(/\t/g,"");
                    //   this.showModal("에러", "TAB은 사용할수 없습니다");
                    // }
                }
            },
            checkSpecialKey: function (str) {
                if (str.includes('"') || str.includes("'")) {
                    str = str.replace(/[^a-zA-Z ]/g, "");
                }
            },
            getStateString: function (state) {
                return getStateString(state);
            },
            getStateTimeString: function(index) {
                return getStateTimeString(this.$data.items[index]);
            },
            sortByAWB: function() {
                this.$data.sortList.awb = !this.$data.sortList.awb;
                if(this.$data.items.length  == 0) {
                    return;
                }
                let self = this;
                this.$data.items.sort(function(a, b){
                    if(a.awb > b.awb) {

                        return self.$data.sortList.awb?1:-1;
                    }
                    return self.$data.sortList.awb?-1:1;
                })
            },
            sortByDispatchDate: function() {
                this.$data.sortList.dispatch_date = !this.$data.sortList.dispatch_date;
                if(this.$data.items.length  == 0) {
                    return;
                }
                let self = this;
                this.$data.items.sort(function(a, b){
                    if(a.dispatch_date > b.dispatch_date) {
                        return self.$data.sortList.dispatch_date?1:-1;
                    }
                    return self.$data.sortList.dispatch_date?-1:1;
                })
            },
            sortByReceiver: function() {
                this.$data.sortList.receiver = !this.$data.sortList.receiver;
                if(this.$data.items.length  == 0) {
                    return;
                }
                let self = this;
                this.$data.items.sort(function(a, b){
                    if(a.receiver > b.receiver) {
                        return self.$data.sortList.receiver?1:-1;
                    }
                    return self.$data.sortList.receiver?-1:1;
                })
            },
            sortByOrderNumber: function() {
                this.$data.sortList.orderNumber = !this.$data.sortList.orderNumber;
                if(this.$data.items.length  == 0) {
                    return;
                }
                let self = this;
                this.$data.items.sort(function(a, b){
                    if(a.order_number > b.order_number) {
                        return self.$data.sortList.orderNumber?1:-1;
                    }
                    return self.$data.sortList.orderNumber?-1:1;
                })
            },

        },


    }
</script>
<style lang="css" scoped>
  .label-container {
    position: fixed;
    top: 30px;
    left: 50%;
    width: 29.7cm;
    height: 90%;
    transform: translateX(-50%);
    overflow-y: scroll;
    background: white;

  }

  .fa-search.form-control {
    background: #3498db;
    color: white;
    font-size: 1rem;
    font-weight: 400;
  }

  .mobile-horizontal-scroll {
    overflow-x: scroll;
  }

  .mobile-product-input-table {
    width: 1000px;
  }
 .table td {
    padding:.25rem;
  }
  .form-control {
    height: calc(1.0em + 1.0rem + 2px);
  }
  .form-group {
    margin-bottom:0.5rem;
  }
  .card-header h4 {
    margin-bottom:0;
  }
  .new-item-form {
    background:#D4D4D4;
  }
  .card {
    box-shadow: 5px 5px 5px grey;
    margin-bottom:20px;
  }
  .page {
    height: 5.9in;
    /*padding-top: 5px;*/
    width: 4in;
    page-break-after: always;
    font-family: Arial, Helvetica, sans-serif;
    position: relative;
    display: inline-block;
    background-color: white;
    /*border: 1px solid black;*/
    /*border-bottom: 1px solid #000;*/
  }
  .item-container {
    width: 100%;
    float: left;
    height: 100%;
    /*background-color: grey;*/
  }
  .item-inner-container {
    width: 90%;
    margin-left: auto;
    margin-right:auto;
    height: 100%;
  }
  .code-container {
    width: 80%;
    margin-left: auto;
    margin-right:auto;
  }
  .header-section {
    width:100%;
    height:15%;
    /*padding-top:5mm;*/
  }
  .code-section {
    width:100%;
    height:10%;
  }
  .sender-section {
    width:100%;
    height: 20%;
  }
  .receiver-section {
    width: 100%;
    height: 35%;
  }
  .bottom-section {
    width:100%;
    height:25%;
    text-align: center;
  }
  .align-center {
    text-align: center;
  }
  .barcode-container > div {
    margin-right: auto;
    margin-left: auto;
  }
  .logo {
    position: absolute;
    top:-5mm;
    /*left:0.2cm;*/
    height:1.8cm;
    left:50%;
    transform:translateX(-50%);

  }
  .list-enter-active, .list-leave-active {
    transition: transform 0.3s ease-in-out;
  }
  .list-enter{
    transform: translateX(-100%);
  }
  .list-leave-to {
    transform: translateX(100%);
  }
  .list-group-item.selected {
    background: blue;
    color:white;

  }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue